/**
 * @generated SignedSource<<04a458e7f841edb731852d3730f96d61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectImprovementsPageQuery$variables = {
  projectPath: string;
  teamPath: string;
};
export type ProjectImprovementsPageQuery$data = {
  readonly team: {
    readonly masterQuestionnaire: {
      readonly id: string;
      readonly indicators: ReadonlyArray<{
        readonly key: string;
        readonly name: string;
        readonly questionIds: ReadonlyArray<string>;
      }>;
      readonly questionnaireId: string;
      readonly questions: ReadonlyArray<{
        readonly fullForm: string;
        readonly id: string;
        readonly isMeta: boolean | null | undefined;
        readonly isSurveyMeta: boolean | null | undefined;
        readonly questionId: string;
        readonly shortForm: string | null | undefined;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"AreaOfImprovementTagSelect_questionnaire">;
    } | null | undefined;
    readonly project: {
      readonly " $fragmentSpreads": FragmentRefs<"AddAreaOfImprovementPage_project" | "ProjectImprovementsPage_project">;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectImprovementsPageQuery = {
  response: ProjectImprovementsPageQuery$data;
  variables: ProjectImprovementsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectPath"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamPath"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "path",
    "variableName": "teamPath"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "projectPath",
    "variableName": "projectPath"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": "questionnaireId",
  "args": null,
  "kind": "ScalarField",
  "name": "originalId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": "questionIds",
  "args": null,
  "kind": "ScalarField",
  "name": "originalQuestionIds",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Question",
  "kind": "LinkedField",
  "name": "questions",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": "questionId",
      "args": null,
      "kind": "ScalarField",
      "name": "originalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullForm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortForm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMeta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSurveyMeta",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  (v3/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Indicator",
  "kind": "LinkedField",
  "name": "indicators",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectImprovementsPageQuery",
    "selections": [
      {
        "alias": "team",
        "args": (v1/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByPath",
        "plural": false,
        "selections": [
          {
            "alias": "project",
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "projectByPath",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectImprovementsPage_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AddAreaOfImprovementPage_project"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Questionnaire",
            "kind": "LinkedField",
            "name": "masterQuestionnaire",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AreaOfImprovementTagSelect_questionnaire"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Indicator",
                "kind": "LinkedField",
                "name": "indicators",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectImprovementsPageQuery",
    "selections": [
      {
        "alias": "team",
        "args": (v1/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByPath",
        "plural": false,
        "selections": [
          {
            "alias": "project",
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "projectByPath",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isProjectInterface"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImprovementBank",
                "kind": "LinkedField",
                "name": "improvementBank",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AreaOfImprovement",
                    "kind": "LinkedField",
                    "name": "areasOfImprovement",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "areaOfImprovementId",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdOn",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImprovementActivity",
                        "kind": "LinkedField",
                        "name": "activities",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "responsiblePerson",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadline",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "completedOn",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "questionnaire",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v13/*: any*/),
                      (v8/*: any*/)
                    ],
                    "type": "Questionnaire",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Questionnaire",
            "kind": "LinkedField",
            "name": "masterQuestionnaire",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v13/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8728cb5442a960e6cc93f24a07953d0",
    "id": null,
    "metadata": {},
    "name": "ProjectImprovementsPageQuery",
    "operationKind": "query",
    "text": "query ProjectImprovementsPageQuery(\n  $projectPath: String!\n  $teamPath: String!\n) {\n  team: teamByPath(path: $teamPath) {\n    project: projectByPath(projectPath: $projectPath) {\n      __typename\n      ...ProjectImprovementsPage_project\n      ...AddAreaOfImprovementPage_project\n      id\n    }\n    masterQuestionnaire {\n      ...AreaOfImprovementTagSelect_questionnaire\n      id\n      questionnaireId: originalId\n      indicators {\n        key\n        name\n        questionIds: originalQuestionIds\n        id\n      }\n      questions {\n        id\n        questionId: originalId\n        fullForm\n        shortForm\n        isMeta\n        isSurveyMeta\n      }\n    }\n    id\n  }\n}\n\nfragment AddAreaOfImprovementPage_project on ProjectInterface {\n  __isProjectInterface: __typename\n  id\n  improvementBank {\n    id\n  }\n}\n\nfragment AreaOfImprovementTagSelect_questionnaire on Questionnaire {\n  ...useAreaOfImprovementTagSelectOptions_questionnaire\n  id\n  questionnaireId: originalId\n  indicators {\n    key\n    name\n    questionIds: originalQuestionIds\n    id\n  }\n  questions {\n    id\n    questionId: originalId\n    fullForm\n    shortForm\n    isMeta\n    isSurveyMeta\n  }\n}\n\nfragment AreasOfImprovement_areasOfImprovement on AreaOfImprovement {\n  id\n  areaOfImprovementId\n  summary\n  slug\n  createdBy {\n    fullName\n    id\n  }\n  createdOn\n  tags {\n    __typename\n  }\n  activities {\n    slug\n    summary\n    responsiblePerson {\n      fullName\n      id\n    }\n    deadline\n    completedOn\n    id\n  }\n}\n\nfragment AreasOfImprovement_questionnaire on Questionnaire {\n  ...useAreaOfImprovementTagSelectOptions_questionnaire\n}\n\nfragment ProjectImprovementsPage_project on ProjectInterface {\n  __isProjectInterface: __typename\n  improvementBank {\n    areasOfImprovement {\n      ...AreasOfImprovement_areasOfImprovement\n      id\n    }\n    id\n  }\n  questionnaire {\n    __typename\n    ...AreasOfImprovement_questionnaire\n    id\n  }\n}\n\nfragment useAreaOfImprovementTagSelectOptions_questionnaire on Questionnaire {\n  id\n  questionnaireId: originalId\n  indicators {\n    key\n    name\n    questionIds: originalQuestionIds\n    id\n  }\n  questions {\n    id\n    questionId: originalId\n    fullForm\n    shortForm\n    isMeta\n    isSurveyMeta\n  }\n}\n"
  }
};
})();

(node as any).hash = "7fb83ae0da5a16889e94073c319988bf";

export default node;
